import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = { percentage: number }

const ChartTooltipPercentage = ({ percentage }: Props) => {
  return (
    <Box alignItems="flexEnd">
      <Text.Normal size="200" weight="normal" color="grey100">
        {i18n.t('insights.widgets.shared.percentage_of_total', {
          percentage: Math.round(percentage),
        })}
      </Text.Normal>
    </Box>
  )
}

export default ChartTooltipPercentage
